import axios from 'axios';
import getUrl from 'utils/getUrl';
import { generateApiError } from 'api/utils/apiErrorMessages';
import settingsSubmissionError from 'api/submissionErrors/settingsSubmissionError';
import { mapLocalStylingToApiModel } from './dataMapper/surveyStylingDataMapper';

export default (collectionPath, id, styling = {}) =>
  axios
    .patch(getUrl.apiV2(`${collectionPath}/${id}`), {
      local_styles: mapLocalStylingToApiModel(styling),
    })
    .catch(generateApiError({ submissionErrorMap: settingsSubmissionError }));
